import React, { useEffect, useState } from "react";
import { Button, Card, Typography } from "@material-ui/core";
import { useCookies } from "react-cookie";
import { ToastContainer } from "react-toastify";
import { DarkGrey } from "../../shared/styles/colors";
import DatabaseEntities from "../../model/enum/DatabaseEntities";
import ApiService from "../../service/ApiService";
import AlertService from "../../service/AlertService";
import Pathnames from "../../model/enum/Pathnames";
import Spinner from "../../shared/components/loader/Spinner";
import VisibilityIcon from "@mui/icons-material/Visibility";
import VisibilityOffIcon from "@mui/icons-material/VisibilityOff";
import ToastMessages from "../../model/enum/ToastMessages";
import User from "../../model/user";
import Auth from "../../model/auth";
import Session from "../../model/session";
import Error from "../../model/error";
import Logo from "../../assets/main.png";
import useStyles from "./styles";
import Misc from "../../utils/Misc";
import "./Login.scss";

const Login = () => {
  const classes = useStyles();
  const [cookies, setCookie] = useCookies(["session"]);

  //TODO: add login with username
  const [username, setUsername] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [errorEmail, setErrorEmail] = useState("");
  const [errorPwd, setErrorPwd] = useState("");
  const [viewPassword, setViewPassword] = useState(false);
  const [loading, setLoading] = useState(false);

  const login = async () => {
    //Misc.validPasswordFormat(password)
    if (Misc.validEmailFormat(email) && !Misc.isNullOrEmpty(password)) {
      setLoading(true);
      setErrorEmail("");
      setErrorPwd("");
      try {
        const payload: Auth = {
          email: email,
          password: password,
        };

        const session: Session = await ApiService.post<Session>(
          `${DatabaseEntities.AUTH}/loginWithEmail`,
          payload
        );

        if (session) {
          setCookie("session", session);
          localStorage.setItem("accessToken", session.accessToken);
          localStorage.setItem("userEmail", email);

          AlertService.success(ToastMessages.LOGGED_IN);

          const user: User = await ApiService.get<User>(
            `${DatabaseEntities.USERS}/${session.userId}`,
            session.accessToken
          );

          localStorage.setItem("userId", user.id.toString());
          localStorage.setItem("userName", user.username);

          setInterval(() => {
            if (!user.activated) {
              window.open(
                Pathnames.ACTIVATE_ACCOUNT +
                  "?userId=" +
                  user.id +
                  "&email=" +
                  email,
                "_self"
              );
            } else {
              window.open(Pathnames.DASHBOARD, "_self");
            }
          }, 3000);
        }
      } catch (error: any) {
        AlertService.error(ToastMessages.LOGIN_FAILED);
      } finally {
        setLoading(false);
      }
    } else {
      AlertService.warning(ToastMessages.INVALID_LOGIN_FORM);
    }
  };

  useEffect(() => {
    const keyDownHandler = (event: {
      key: string;
      preventDefault: () => void;
    }) => {
      if (event.key === "Enter") {
        event.preventDefault();
        login();
      }
    };

    document.addEventListener("keydown", keyDownHandler);

    return () => {
      document.removeEventListener("keydown", keyDownHandler);
    };
  });

  const handleEmailChange = (e: any) => {
    const value = e.target.value;
    setEmail(value);
    if (value === "") setErrorEmail("");
  };

  const handlePwdChange = (e: any) => {
    const value = e.target.value;
    setPassword(value);
    if (value === "") setErrorPwd("");
  };

  return (
    <div className={classes.login}>
      <Card className={classes.loginCard}>
        <img src={Logo} className={classes.logo} alt="logo" />
        <div className="form__group">
          <input
            type="input"
            className={classes.input}
            placeholder="myemail@setupremodeling.com"
            name="email"
            id="email"
            required
            value={email}
            onChange={handleEmailChange}
          />
          <label className="form__label">Email</label>
        </div>
        <label className={classes.errorText}>{errorEmail}</label>
        <div className="form__group">
          <div className={classes.inputDiv}>
            <input
              type={viewPassword ? "text" : "password"}
              className={classes.emptyInput}
              placeholder="**********"
              name="password"
              id="password"
              required
              value={password}
              onChange={handlePwdChange}
            />
            <label className="form__label">Password</label>
            {viewPassword ? (
              <Button onClick={() => setViewPassword(!viewPassword)}>
                <VisibilityOffIcon />
              </Button>
            ) : (
              <Button onClick={() => setViewPassword(!viewPassword)}>
                <VisibilityIcon />
              </Button>
            )}
          </div>
        </div>
        <label className={classes.errorText}>{errorPwd}</label>
        <button className={classes.button} onClick={login} disabled={loading}>
          Login
        </button>
        {error ? <p className={classes.errorText}>{error}</p> : null}
        {loading && <Spinner />}
        <hr style={{ width: "20%" }} />
        <div className={classes.checkboxDiv}>
          <Typography style={{ color: DarkGrey, fontSize: ".9rem" }}>
            V1.4.2
          </Typography>
        </div>
      </Card>
      <ToastContainer />
    </div>
  );
};

export default Login;
